<template>
  <div>
    <annkissam-modal ref="annkissamModal"/>
    <wovnio-modal ref="wovnioModal"/>
    <toptal-modal ref="toptalModal"/>
    <the-increaser-modal ref="theIncreaserModal"/>
    <transition name="top-down">
      <div id="app">
        <div class="">
          <nav-bar></nav-bar>
          <intro></intro>
        </div>
        <div>
          <projects-section/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Intro from '../components/Intro.vue'
import NavBar from '../components/NavBar.vue'
import ProjectsSection from '../components/ProjectsSection.vue'
import AnnkissamModal from '../components/AnnkissamModal.vue'
import WovnioModal from '../components/WovnioModal.vue'
import ToptalModal from '../components/ToptalModal.vue'
import TheIncreaserModal from '../components/TheIncreaserModal.vue'

export default {
  name: 'App',
  components: {
    Intro,
    NavBar,
    ProjectsSection,
    AnnkissamModal,
    WovnioModal,
    ToptalModal,
    TheIncreaserModal
  },
  methods: {
    openAnnkissam () {
      this.$refs.annkissamModal.open()
    },
    openWovnio () {
      this.$refs.wovnioModal.open()
    },
    openToptal () {
      this.$refs.toptalModal.open()
    },
    openTheIncreaser () {
      this.$refs.theIncreaserModal.open()
    }
  }
}
</script>

<style>
#app {
  min-width: 252px;
}

.top-down-enter-active {
  transition: all 1s ease;
}
.top-down-leave-active {
  transition: all 1s;
}
.top-down-enter, .top-down-leave-to {
  background-color: black;
  height: 0px;
  opacity: 0.5;
  overflow: hidden;
}
</style>
